import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, ErrorHandler, importProvidersFrom, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideOAuthClient } from 'angular-oauth2-oidc';
import { APP_ROUTES } from './app.routes';
import { AppAuthenticationService, AuthInterceptor } from '@cumlaude/shared-authentication';
import { BugsnagService } from '@cumlaude/bugsnag';
import { AdminBugsnagService } from '@cumlaude/admin-bugsnag';
import { AdminAuthenticationService } from '@cumlaude/admin-authentication';
import { ParamEncodingInterceptor } from '@cumlaude/shared-utils';
import { ENV_CONFIG, EnvConfiguration } from '@cumlaude/shared-configuration';
import { BugsnagErrorHandler } from '@bugsnag/plugin-angular';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { AppMenuService, AppRoutesService } from '@cumlaude/shared-components-menu';
import { AdminMenuService } from './services/admin-menu.service';
import { AdminRoutesService } from './services/admin-routes.service';

export const createAppConfig = (envConfig: EnvConfiguration): ApplicationConfig => ({
	providers: [
		{ provide: ENV_CONFIG, useValue: envConfig },
		importProvidersFrom(BrowserModule),
		provideZoneChangeDetection(),
		provideOAuthClient(),
		{
			provide: HTTP_INTERCEPTORS,
			multi: true,
			useClass: AuthInterceptor,
		},
		{
			multi: true,
			provide: HTTP_INTERCEPTORS,
			useClass: ParamEncodingInterceptor,
		},
		{
			provide: BugsnagService,
			useClass: AdminBugsnagService,
		},
		{
			provide: ErrorHandler,
			useFactory(envConfig: EnvConfiguration) {
				if (envConfig.bugsnagApiKey) {
					return new BugsnagErrorHandler();
				}
				return new ErrorHandler();
			},
			deps: [ENV_CONFIG],
		},
		{
			provide: AppAuthenticationService,
			useClass: AdminAuthenticationService,
		},
		{
			provide: AppMenuService,
			useClass: AdminMenuService,
		},
		{
			provide: AppRoutesService,
			useClass: AdminRoutesService,
		},
		{
			provide: LOCALE_ID,
			useValue: 'nl-NL',
		},
		provideHttpClient(withInterceptorsFromDi(), withFetch()),
		provideRouter(APP_ROUTES, withComponentInputBinding()),
	],
});
